import { OmitGroupIdInHeader } from '@src/types/util';

import { authenticateRequest } from '@api/authenticateRequest';

import type { GetAssociationLicenseMembersResponse } from '@type/group';
import type { operations } from '@type/model';

type GetAssociationLicenseMembersQuery =
  operations['AdminKcplaaMemberController_getKcplaaMemberListV2']['parameters']['query'];
type GetAssociationLicenseMembersHeaders =
  operations['AdminKcplaaMemberController_getKcplaaMemberListV2']['parameters']['header'];
interface GetAssociationLicenseMembersProps {
  query: GetAssociationLicenseMembersQuery;
  headers?: OmitGroupIdInHeader<GetAssociationLicenseMembersHeaders>;
}

export async function getAssociationLicenseMembers({
  query,
}: GetAssociationLicenseMembersProps): Promise<GetAssociationLicenseMembersResponse | false> {
  const response = await authenticateRequest<GetAssociationLicenseMembersResponse>({
    method: 'get',
    url: `/api/v2/admin/kcplaa/members`,
    params: query,
  });

  console.log('getAssociationMembers', { response, query });

  return response;
}

export type { GetAssociationLicenseMembersQuery };
